import { Component, Injector, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'mission-particulier',
    templateUrl: './mission-particulier.component.html',
    styleUrls: ['./mission-particulier.component.scss'],
    standalone: false
})
export class MissionParticulierComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  options: FormControlOption[] = [
    {
      label: 'Pack essentiel',
      value: 'PACK_ESSENTIEL',
      displayValue:
        '<span class="description"> <span class="displayValue">498€ </span>TTC par an',
      displayValueAsHtml: true,
      suffix: 'D',
      formControlName: 'packEssentielOption',
      input: {
        formControlName: 'packEssentiel',
      },
      description:
        ' Collecte, saisie et production des liasses fiscales. Accompagnement pour le report de votre résultat d’activité de loueur meublée sur votre déclaration de revenus personnelle.',
    },
    {
      label: 'Pack revenus fonciers',
      value: 'PACK_ESSENTIEL_REVENUS_FONCIERS',
      displayValue:
        '<span class="description"> <span class="displayValue">180€ </span>TTC par an',
      displayValueAsHtml: true,
      suffix: 'E',
      formControlName: 'packEssentielRevenusFonciersOption',
      input: {
        formControlName: 'packEssentielRevenusFonciers',
      },
      description:
        'Accompagnement pour le report de votre résultat d’activité de loueur sur votre déclaration de revenus personnelle.',
    },
    {
      label: 'Pack revenus fonciers avec dispositif (Pinel, Malraux,…)',
      value: 'PACK_ESSENTIEL_REVENUS_FONCIERS_AVEC_DISPOSITIF',
      displayValue:
        '<span class="description"> <span class="displayValue">225€ </span>TTC par an',
      displayValueAsHtml: true,
      suffix: 'F',
      formControlName: 'packEssentielRevenusFonciersAvecDispositifOption',
      input: {
        formControlName: 'packEssentielRevenusFonciersAvecDispositif',
      },
      description:
        'Accompagnement pour le report de votre résultat d’activité de loueur sur votre déclaration de revenus personnelle.',
    },
    {
      label: 'IRPP',
      value: 'IRPP',

      formControlName: 'IRPPOption',
      input: {
        formControlName: 'irpp',
      },
      description: 'Accompagnement pour la déclaration des revenus locatifs.',
    },
    {
      label: 'IFI',
      value: 'IFI',
      suffix: 'B',
      formControlName: 'IFIOption',
      input: {
        formControlName: 'ifi',
      },
      description:
        'Accompagnement pour la déclaration d’impôt sur les revenus.',
    },
    {
      label: 'Reprise de comptabilité jusqu’à 3 ans',
      value: 'accountingTakeover',
      suffix: 'C',
      formControlName: 'accountingTakeoverOption',
      input: {
        formControlName: 'accountingTakeover',
      },
      description:
        'Reprise de la comptabilité de l’activité du loueur jusqu’au 3 dernières années',
    },
  ];
  isConsultant: boolean = false;
  optionInfo: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  contractActive: boolean;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
    private sanitizer: DomSanitizer,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.isConsultant = !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    if (!this.isConsultant) {
      this.options = this.options.filter(
        option =>
          option.value != 'IFI' &&
          option.value != 'IRPP' &&
          option.value != 'accountingTakeover',
      );
    }
    this.subscriptionFacade.initForm(this);
    this.contractActive =
      this.subscriptionFacade.getPledge()?.products?.[0]?.parameters?.isContractActive;
    if (this.contractActive && this.isConsultant) {
      this.options.forEach(option => (option.displayValue = false));
    }
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  select(option: FormControlOption) {
    const checked = this.products
      .get('0')
      ?.get('parameters')
      ?.get(option.formControlName)?.value;

    if (!checked) {
      this.products
        .get('0')
        ?.get('parameters')
        ?.get(option.formControlName)
        ?.setValue(true);
    }
  }
  getDisplayValueAsHtml(option: FormControlOption): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(option.displayValue || '');
  }
}
